import {
  useGetSalesforceInvoicesList,
  useGetSalesforceInvoiceDocument,
} from 'services/reactQueryHooks/salesforceInvoices';
import { useState, useEffect } from 'react';

const useSalesforceInvoicesPage = ({ timeFrame }) => {
  const [invoiceId, setInvoiceId] = useState(null);
  const {
    data: salesforceInvoicesSummaryList,
    isSuccess: isSalesforceInvoiceSummaryListSuccess,
    isError: isSalesforceInvoiceSummaryListError,
  } = useGetSalesforceInvoicesList(timeFrame);

  const {
    isSuccess: isDownloadSuccess,
    isFetching: isDownloading,
    isError: isDownloadError,
  } = useGetSalesforceInvoiceDocument(invoiceId);

  useEffect(() => {
    if ((invoiceId && !isDownloading && isDownloadSuccess) || (isDownloadError && invoiceId)) {
      setInvoiceId(null);
    }
  }, [isDownloading, isDownloadSuccess, invoiceId, isDownloadError]);

  const handleDownloadPdf = ({ invoiceId }) => {
    setInvoiceId(invoiceId);
  };

  return {
    salesforceInvoicesSummaryList,
    isSalesforceInvoiceSummaryListSuccess,
    isSalesforceInvoiceSummaryListError,
    handleDownloadPdf,
  };
};

export default useSalesforceInvoicesPage;
